<template>
  <div>
    <div class="d-flex align-items-center mb-3">
      <div>
        <h1 class="page-header mb-0">
          <i class="fas fa-print"></i> Letölthető dokumentumok
        </h1>
      </div>
    </div>
    <panel title="Letölthető dokumentumok vállalkozók részére">
      <table>
        <tr
          v-for="permit in external_permits.filter(
            (permit) => permit.file !== null
          )"
          :key="permit.id"
        >
          <td class="p-2">
            <a :href="permit.file">
              <i class="fa fa-2x fa-download"></i>
            </a>
          </td>
          <td>{{ permit.name }}</td>
        </tr>
      </table>
    </panel>
  </div>
</template>

<script>
export default {
  data() {
    return {
      external_permits: [],
    };
  },
  created() {
    this.external_permits = JSON.parse(
      localStorage.getItem("constants")
    ).external_permits;
  },
};
</script>
